import type { ReactNode } from "react";
import { cn } from "./cn";

// Paper: 13e update and crash. A floating note for something that happened outside the
// current view. The title carries the tone (attention for what needs the human); the
// action slot is a fixed 76px so stacked toasts line their buttons up.

export const ToastStack = ({ className, children }: { className?: string; children: ReactNode }) => (
  <div role="region" aria-label="Notifications" className={cn("flex w-[360px] flex-col gap-2", className)}>
    {children}
  </div>
);

export const Toast = ({
  title,
  description,
  action,
  tone = "neutral",
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  tone?: "neutral" | "attention" | "negative";
  className?: string;
}) => (
  <div
    role="status"
    className={cn(
      "flex items-start gap-3 rounded-inner bg-surface px-3.5 py-3 shadow-[inset_0_1px_0_#ffffff0f,0_0_0_1px_var(--color-line),0_8px_24px_#00000080]",
      className,
    )}
  >
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <p
        className={cn(
          "text-[13px] font-medium leading-4 tracking-ui",
          tone === "attention" ? "text-attention" : tone === "negative" ? "text-negative" : "text-text",
        )}
      >
        {title}
      </p>
      {description === undefined ? null : (
        <p className="text-[12px] leading-4 tracking-normal text-text-2">{description}</p>
      )}
    </div>
    {action === undefined ? null : <div className="flex w-[76px] shrink-0 justify-end">{action}</div>}
  </div>
);
